import React from "react";
import logoPreto from "../../assets/images/logo-preto.png";
import { ShowNotification, NotificationType } from "@utils";
import "./styles.css";
import { getLocalStorageItem } from "@utils";

import AcceptTermsModal from "./components/modal";

const Lobby = ({ setScreenToShow, setSessionId, userType }) => {
  const handleIniciarSessao = () => {
    if (userType === "agr") {
      setSessionId(getLocalStorageItem("SESSION"));
      ShowNotification(
        NotificationType.Warn,
        "Sempre que gravar uma videoconferência precisa validar um código OTP novo",
      );
    }

    setScreenToShow("videoconferencia");
  };

  const abrirModal = (nomeModal) => {
    setTimeout(() => {
      document.getElementById(nomeModal).click();
    }, 500);
  };

  const abrirModalConfirmacaoFoto = () => {
    abrirModal("modal-open");
  };

  const handleEntrarSala = () => {
    if (userType === "agr") {
      handleIniciarSessao();
    }
    abrirModalConfirmacaoFoto();
  };

  return (
    <>
      <div className="card-container">
        <div className="card-header">
          <img className="img-logo" src={logoPreto} alt="AC Digital" />
        </div>

        <div className="card-bottom">
          <button
            onClick={handleEntrarSala}
            className="button-primary button-join-room"
          >
            Entrar
          </button>
        </div>
      </div>

      <AcceptTermsModal handleIniciarSessao={handleIniciarSessao} />
      <a id="modal-open" href="#modal-one" style={{ display: "none" }}>
        Abrir termo de consentimento
      </a>
    </>
  );
};

export default Lobby;
